<template>
  <div class="container">
    <breadcrumb :list="breadcrumbList"></breadcrumb>
    <el-card class="main">
      <!-- 用户卡片 -->
      <div class="userCard">
        <div class="userData">
          <div class="username">{{ dataForm.csmc }}</div>
        </div>
        <img class="illustration" src="@/assets/img/illustration.png" alt="" />
      </div>
      <div class="subject">
        <el-row type="flex" class="subject_title">
          <img src="@/assets/img/tag.png" alt="" />
          <span class="title_text">企业信息</span>
        </el-row>

        <!-- 放置表格 -->

        <el-descriptions
          border
          :column="3"
          labelClassName="labelWidth"
          contentClassName="contentStyle"
        >
          <el-descriptions-item label="管辖机构"
            >{{ dataForm.gethouseinfo.hi_dwmc }}
          </el-descriptions-item>
          <el-descriptions-item :label="zzlxdm"
            >{{ dataForm.tyshxydm }}
          </el-descriptions-item>
          <el-descriptions-item label="场所编码">
            {{ dataForm.cs_dmsn }}
          </el-descriptions-item>
          <el-descriptions-item label="行业类别">{{
            dataForm.ylcslxdm | ylcslxdmFilter
          }}</el-descriptions-item>
          <el-descriptions-item label="单位类别">{{
            dataForm.dwlb | dwlbFilter
          }}</el-descriptions-item>
          <el-descriptions-item label="九小场所">{{
            dataForm.jxcs | jxcsFilter
          }}</el-descriptions-item>
          <el-descriptions-item label="经营状态">{{
            dataForm.cs_jyztdm | jyztFilter
          }}</el-descriptions-item>
          <el-descriptions-item label="经营面积"
            >{{ dataForm.cs_mjpfm }}㎡</el-descriptions-item
          >
          <el-descriptions-item label="联系电话">{{
            dataForm.cs_lxdh
          }}</el-descriptions-item>
          <el-descriptions-item label="消防等级">{{
            dataForm.xfdj | xfdjFilter
          }}</el-descriptions-item>
          <el-descriptions-item label="开业日期">{{
            dataForm.cs_kyrq
          }}</el-descriptions-item>
          <el-descriptions-item label="核定消费者人数"
            >{{ dataForm.hdxfz_sl }}人</el-descriptions-item
          >
          <el-descriptions-item label="包厢数量">
            {{ dataForm.bx_fwjs }}间</el-descriptions-item
          >
          <el-descriptions-item label="法定代表人">{{
            dataForm.fddbr_xm
          }}</el-descriptions-item>
          <el-descriptions-item label="法定代表人电话">{{
            dataForm.fddbr_lxdh
          }}</el-descriptions-item>
          <el-descriptions-item label="法定代表人证件号码">{{
            dataForm.fddbr_zhm
          }}</el-descriptions-item>
          <el-descriptions-item label="负责人姓名">{{
            dataForm.csfzr_xm
          }}</el-descriptions-item>
          <el-descriptions-item label="负责人电话">{{
            dataForm.csfzr_lxdh
          }}</el-descriptions-item>
          <el-descriptions-item label="负责人身份证号">{{
            dataForm.csfzr_sfzhm
          }}</el-descriptions-item>
          <el-descriptions-item label="治安负责人">{{
            dataForm.zafzr
          }}</el-descriptions-item>
          <el-descriptions-item label="治安负责人联系电话">{{
            dataForm.zafzr_lxdh
          }}</el-descriptions-item>
          <el-descriptions-item label="治安负责人证件号">{{
            dataForm.zafzr_zjh
          }}</el-descriptions-item>
          <el-descriptions-item label="备案编号">{{
            dataForm.thbabh
          }}</el-descriptions-item>
          <el-descriptions-item label="门头名称">{{
            dataForm.mt_mc
          }}</el-descriptions-item>
          <el-descriptions-item label="娱乐场所备案证号">{{
            dataForm.hyjyxkzhm
          }}</el-descriptions-item>
          <el-descriptions-item label="娱乐场所备案机构">{{
            dataForm.hyjyxkzfzjgmc
          }}</el-descriptions-item>
          <el-descriptions-item label="门头照片" span="3">
            <el-image
              v-for="item in imgList"
              :key="item"
              fit="contain"
              style="width: 200px; height: 100px; padding: 5px"
              :src="item"
              :preview-src-list="imgList"
            />
          </el-descriptions-item>
        </el-descriptions>
        <CheckStandard
          class="standard"
          :list="dataForm.gethouseinfo"
          :is_ybss="dataForm.is_ybss"
        ></CheckStandard>
        <div class="subject_btn" style="text-align: center">
          <el-button type="primary" @click="revise" class="">修改</el-button>
        </div>

        <!-- /放置表格 -->
      </div>
      <!-- 账号到期提示弹出层  仅弹出一次-->
      <no-time
        v-if="$store.state.no_time"
        :dialogVisible="dialogVisible"
        @updata="updata"
      ></no-time>
    </el-card>

    <el-dialog
      :visible.sync="receiptVisible"
      center
      width="60%"
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      class="dialog"
      
    >
      <template #title>
        <div
          style="
            font-size: 20px;
            font-weight: 500;
            color: #6345d5;
            border-bottom: 1px #6345d5 solid;
            padding-bottom: 15px;
          "
        >
          公告详情
        </div>
      </template>
      <div style="height: 600px; overflow: auto" ref="scrollContainer">
        <div style="font-size: 20px; font-weight: 600; text-align: center">
          {{ noticeData.title }}
        </div>
        <div v-html="noticeData.content"></div>
        <div class="receiptForm">
          <el-form
            :model="addForm"
            ref="addFormRef"
            :rules="addFormRules"
            label-width="auto"
          >
            <el-form-item label="回执描述" prop="receipt">
              <el-input
                v-model="addForm.receipt"
                clearable
                type="textarea"
                showWordLimit
                resize="none"
                maxlength="200"
                rows="5"
              />
            </el-form-item>
          </el-form>
        </div>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button type="info" @click="closenotice">取 消</el-button>
        <el-button type="primary" @click="submit" :loading="submitBtnLoading"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import * as user from '@/api/user'
import NoTime from './components/no_time.vue'
import Breadcrumb from '@/components/breadcrumb'
import { filtersInfo, lists } from '@/utils/dictionary.js'
import CheckStandard from './check_standard.vue'
let that
export default {
  name: 'EnterpriseInformationIndex',
  components: { Breadcrumb, NoTime, CheckStandard },
  data() {
    return {
      imgList: [],
      breadcrumbList: [
        // 面包屑所需数据
        { name: '企业信息', path: 'enterprise_information' }
      ],
      dataForm: {
        gethouseinfo: {
          hi_dwmc: ''
        },
        tyshxydm: '',
        cs_dzmc: '',
        ylcslxdm: '',
        cs_mjpfm: ''
      },
      zzlxdm: '',
      zzlxdmList: '',
      ylcslxdmList: [], //行业类别字典
      dwlbList: [], //单位类别字典
      jyztdmList: [], //营业状态字典
      xfdjList: [], //消防等级字典
      dialogVisible: true,
      // 通知公告数据
      receiptlist: [],
      showIndex: 0,
      // 公告详情弹窗是否显示
      receiptVisible: false,
      addFormRef: '',
      noticeData: {},
      submitBtnLoading: false,
      // 回执表单数据
      addForm: {
        notice_id: '',
        receipt: ''
      },
      // 回执表单校验规则
      addFormRules: {
        receipt: [
          { required: true, message: '请输入回执描述', trigger: 'blur' }
        ]
      }
    }
  },
  beforeCreate() {
    that = this
  },
  async created() {
    this.info()
    this.getNosignNotice()
  },
  methods: {
    // 重置弹窗滚动位置
    resetScroll() {
      this.$nextTick(() => {
        console.log('this.$refs.scrollContainer', this.$refs.scrollContainer)
        if (this.$refs.scrollContainer) {
          this.$refs.scrollContainer.scrollTop = 0
        }
      })
    },
    // 获取未签收的通知公告
    async getNosignNotice() {
      const res = await user.getNoticeList({
        page_no: 1,
        page_size: 10,
        is_signed: 0
      })
      console.log('res', res)
      if (res.total_result > 0) {

        this.receiptVisible = true
        this.receiptlist = res.items
        this.noticeData = res.items[this.showIndex]
        this.addForm.notice_id = this.noticeData.id
        this.showIndex++
      }
    },
    closenotice() {
      this.receiptVisible = false
      this.addForm.receipt = "";
      
      if (this.showIndex < this.receiptlist.length) {
        this.noticeData = this.receiptlist[this.showIndex]
        this.addForm.notice_id = this.noticeData.id
        this.showIndex++
        this.receiptVisible = true
        this.resetScroll()
      }
    },
    submit() {
      this.$refs['addFormRef'].validate(async (valid) => {
        if (valid) {
          const res = await user.receiptNotice(this.addForm)
          console.log('123', res)
          this.$message({
            message: '回执成功！',
            type: 'success'
          })
          this.addForm.receipt = ''
          if (this.showIndex < this.receiptlist.length) {
            this.showIndex = this.showIndex - 1
            setTimeout(() => {
              this.getNosignNotice()
              this.resetScroll()
            }, 1000)
          }
          this.receiptVisible = false
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    async info() {
      await user.dictList()
      // 总数据
      const res = await user.getEnterpriseDetails(
        this.$store.state.user.userInfo.place_id
      )
      this.dataForm = res
      this.$store.commit('user/setBasicInfo', res)
      // //营业执照类别字典
      this.zzlxdmList = lists['DWBM']
      this.zzlxdm = filtersInfo(that.zzlxdmList, res.zzlxdm)
      // //行业类别字典
      this.ylcslxdmList = lists['YLCSLXDM']
      // //单位类别字典
      this.dwlbList = lists['DWLB']
      // //经营状态字典
      this.jyztdmList = lists['JYZT']
      // //消防等级字典
      this.xfdjList = lists['XFDJ']
      // //九小场所字典
      this.jxcsList = lists['JXCS']
      if (this.dataForm.cs_xp) {
        this.imgList = this.dataForm.cs_xp.split(',')
      }
    },
    goBack() {
      //返回
      this.$router.back(-1)
    },
    revise() {
      //点击修改,跳转修改页面
      this.$router.push('/enterprise_information/set_enterprise')
    },
    updata() {
      this.$store.commit('set_no_time')
    }
  },
  filters: {
    ylcslxdmFilter(val) {
      if (val != 0 && !val) return ''
      return filtersInfo(that.ylcslxdmList, val)
    },
    dwlbFilter(val) {
      if (val != 0 && !val) return ''
      return filtersInfo(that.dwlbList, val)
    },
    jyztFilter(val) {
      if (val != 0 && !val) return ''
      return filtersInfo(that.jyztdmList, val)
    },
    xfdjFilter(val) {
      if (val != 0 && !val) return ''
      return filtersInfo(that.xfdjList, val)
    },
    jxcsFilter(val) {
      if (val != 0 && !val) return ''
      return filtersInfo(that.jxcsList, val)
    }
  }
}
</script>

<style lang="less" scoped>
.main {
  margin: 20px;
  padding: 28px 20px;

  .userCard {
    position: relative;
    background: linear-gradient(90deg, #ffffff 0%, #efebff 100%);
    min-width: 1080px;
    height: 228px;
    border: 1px solid #fff;
    border-radius: 8px;

    .userData {
      margin: 91px 0 0 186px;

      .username {
        margin-bottom: 21px;
        font-size: 30px;
        font-family: Source Han Sans SC;
        font-weight: bold;
        color: #6345d5;
      }

      .cs_dmsn {
        font-size: 16px;
        font-family: Source Han Sans SC;
        font-weight: 500;
        color: #747780;
      }
    }

    .illustration {
      width: 518px;
      height: 259px;
      position: absolute;
      bottom: -17px;
      right: 0;
    }
  }

  .subject {
    .subject_title {
      padding: 32px 0 15px 0;

      img {
        width: 30px;
        height: 39px;
        margin-right: 3px;
      }

      .title_text {
        font-size: 18px;
        line-height: 36px;
        font-family: Source Han Sans SC;
        font-weight: bold;
        color: #6345d5;
      }
    }

    /deep/ .labelWidth {
      min-width: 180px;
    }

    /deep/ .contentStyle {
      min-width: 180px;
    }

    // .subject_table {
    // 	// margin-bottom: 100px;

    // 	/deep/.ellipsis {
    // 		display: flex;
    // 		align-items: center;
    // 		justify-content: space-between;

    // 		// 溢出的部分隐藏；
    // 		.el-tag {
    // 			width: 50px;
    // 			height: 22px;
    // 			border-radius: 11px;
    // 			font-size: 14px;
    // 			font-family: Source Han Sans SC;
    // 			font-weight: 500;
    // 			color: #6345D5;
    // 		}
    // 	}
    // }

    .standard {
      margin: 20px 0 50px 0;
    }

    // .subject_btn {
    // 	.el-button {
    // 		width: 80px;
    // 		border: 1px solid #6345D5;
    // 		background-color: #fff;
    // 		color: #6345D5;
    // 		font-size: 16px;
    // 		border-radius: 6px;
    // 	}

    // 	.reviseBtn {
    // 		margin-left: 27px;
    // 		background-color: #6345D5;
    // 		color: #fff;
    // 	}
    // }
  }
}
/deep/ .el-dialog {
  margin-top: 10vh !important;
}
</style>
